exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orgForm[data-v-6274c760] {\n  width: 80%;\n  margin: 0 auto;\n}\n.el-form-item[data-v-6274c760] {\n  margin-bottom: 12px;\n}\n.el-select[data-v-6274c760] {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n}\n[data-v-6274c760] .el-input-group__append {\n  padding: 0 10px;\n}\n", ""]);

// exports
